/* global Swiper */

document.querySelectorAll( '.b-testimonial-box-container' ).forEach( ( block ) => {

	let prevButton = null;
	let nextButton = null;


	if ( block.id ) {

		const sliderController = document.querySelector( `[data-slider-id="${block.id}"]` );
		if ( sliderController ) {

			prevButton = sliderController.querySelector( '.b-intro__slider-button--prev' )
			nextButton = sliderController.querySelector( '.b-intro__slider-button--next' )

		}

	}

	const slider = block.querySelector( '.swiper' )

	if ( slider ) {

		let swiperBreakpoints = {}
		const layoutElement = slider.querySelector( '.b-testimonial-box-container-grid' );

		if ( layoutElement.classList.contains( 'b-testimonial-box-container-grid--2' ) ) {

			swiperBreakpoints = {
				0: {
					slidesPerView: 1.05,
					spaceBetween: 12,
				},
				576: {
					slidesPerView: 1,
					spaceBetween: 16,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 24,
				}
			}

		} else {

			swiperBreakpoints = {
				0: {
					slidesPerView: 1.05,
					spaceBetween: 12,
				},
				576: {
					slidesPerView: 1,
					spaceBetween: 16,
				},
				768: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 1,
					spaceBetween: 24,
				}
			}

		}

		new Swiper( slider, {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 12,
			watchOverflow: true,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
			breakpoints: swiperBreakpoints,
		} );

	}


} )

